import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { ResourceIcon } from "../generic/icon/ResourceIcon";
export var EventPrizesRewards = function (_a) {
    var rewards = _a.rewards;
    var MaxDisplayedItems = 3;
    var renderedItems = rewards.reduce(function (accumulator, reward, index) {
        if (index >= MaxDisplayedItems) {
            return accumulator;
        }
        accumulator.push(React.createElement("div", { key: reward.id },
            React.createElement(ResourceIcon, { styleId: IdStyles.IconExtraLarge, resource: reward })));
        return accumulator;
    }, []);
    return React.createElement("div", { className: "event-prizes__rewards flex flex--around" }, renderedItems);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/EventPrizesRewards.tsx
// module id = 2774
// module chunks = 3